import React from "react";
import {
  DISABLED_UPLOAD_CLASS,
  ENABLED_UPLOAD_CLASS,
  UPLOAD_BUTTON_BASE_CLASS,
} from "./attachmentPanel.constants";

const AttachmentUploadButton = ({
  acceptedFileTypes,
  isDisabled,
  label,
  onSelectFiles,
}) => {
  const handleFilesChange = (event) => {
    onSelectFiles(Array.from(event.target.files ?? []));
    event.target.value = "";
  };

  return (
    <label
      className={`${UPLOAD_BUTTON_BASE_CLASS} ${
        isDisabled ? DISABLED_UPLOAD_CLASS : ENABLED_UPLOAD_CLASS
      }`}
    >
      {label}
      <input
        accept={acceptedFileTypes}
        className="hidden"
        disabled={isDisabled}
        multiple
        onChange={handleFilesChange}
        type="file"
      />
    </label>
  );
};

export default AttachmentUploadButton;
